import { z } from 'zod'

export const FilterField = z.enum([
  'from',
  'to',
  'cc',
  'subject',
  'header',
  'body',
  'size',
  'envelope-from',
  'envelope-to'
])
export type FilterField = z.infer<typeof FilterField>

export const FilterOp = z.enum(['contains', 'is', 'matches', 'regex', 'over', 'under'])
export type FilterOp = z.infer<typeof FilterOp>

export const FilterCondition = z.object({
  field: FilterField,
  header_name: z.string().optional(),
  op: FilterOp,
  value: z.string().default(''),
  case_sensitive: z.boolean().optional(),
  negate: z.boolean().optional()
})
export type FilterCondition = z.infer<typeof FilterCondition>

export const FilterActionType = z.enum([
  'fileinto',
  'copy-fileinto',
  'mark-read',
  'flag',
  'forward',
  'discard',
  'reject',
  'stop'
])
export type FilterActionType = z.infer<typeof FilterActionType>

export const FilterAction = z.object({
  type: FilterActionType,
  folder: z.string().optional(),
  flag: z.string().optional(),
  address: z.string().optional(),
  reason: z.string().optional(),
  create_folder: z.boolean().optional()
})
export type FilterAction = z.infer<typeof FilterAction>

export const FilterMatch = z.enum(['all', 'any'])
export type FilterMatch = z.infer<typeof FilterMatch>

export const FilterRules = z.object({
  match: FilterMatch.default('all'),
  stop_on_match: z.boolean().default(false),
  conditions: z.array(FilterCondition).default([]),
  actions: z.array(FilterAction).min(1)
})
export type FilterRules = z.infer<typeof FilterRules>

export const FilterMode = z.enum(['builder', 'raw'])
export type FilterMode = z.infer<typeof FilterMode>

export const MailFilter = z.object({
  id: z.number(),
  name: z.string(),
  enabled: z.boolean(),
  order: z.number(),
  mode: FilterMode,
  rules: FilterRules.optional(),
  raw_script: z.string().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional()
})
export type MailFilter = z.infer<typeof MailFilter>

export const CreateFilterRequest = z.object({
  name: z.string().min(1).max(80),
  enabled: z.boolean().optional(),
  mode: FilterMode,
  rules: FilterRules.optional(),
  raw_script: z.string().optional()
})
export type CreateFilterRequest = z.infer<typeof CreateFilterRequest>

export const UpdateFilterRequest = z.object({
  name: z.string().min(1).max(80).optional(),
  enabled: z.boolean().optional(),
  mode: FilterMode.optional(),
  rules: FilterRules.optional(),
  raw_script: z.string().optional()
})
export type UpdateFilterRequest = z.infer<typeof UpdateFilterRequest>

export const ReorderFiltersRequest = z.object({
  order: z.array(z.number())
})
export type ReorderFiltersRequest = z.infer<typeof ReorderFiltersRequest>

export const ImportSieveRequest = z.object({
  script: z.string().min(1),
  name: z.string().optional()
})
export type ImportSieveRequest = z.infer<typeof ImportSieveRequest>

export const ValidateFilterRequest = z.object({
  rules: FilterRules.optional(),
  raw_script: z.string().optional()
})
export type ValidateFilterRequest = z.infer<typeof ValidateFilterRequest>

export const ValidateFilterResponse = z.object({
  valid: z.boolean(),
  error: z.string().optional(),
  generated_script: z.string().optional(),
  requires: z.array(z.string()).optional()
})
export type ValidateFilterResponse = z.infer<typeof ValidateFilterResponse>
